import { render, staticRenderFns } from "./IndustryPointChart.vue?vue&type=template&id=3a4e260c&scoped=true&"
import script from "./IndustryPointChart.vue?vue&type=script&lang=js&"
export * from "./IndustryPointChart.vue?vue&type=script&lang=js&"
import style0 from "./IndustryPointChart.vue?vue&type=style&index=0&id=3a4e260c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e260c",
  null
  
)

export default component.exports